export const BackendToUI = {
  alumnus: 'alumni',
  recruiter: 'recruiter',
  admin: 'admin',
}
